const Routes = {
  about: "/about",
  print: "/print",
  printToc: "/print-terms-and-conditions",
  account: {
    index: "/account",
    order: (id) => `/account/orders/${id}`,
  },
  cart: {
    index: "/cart",
    checkoutIndex: "/cart/checkout",
    checkoutConfirm: "/cart/checkout/confirm",
  },
  fonts: {
    index: "/fonts",
    trial: "/trial",
    family: (fontName) => `/fonts/${fontName}`.toLowerCase(),
    add: {
      licenseUsage: (fontName) =>
        `/fonts/add/license-usage?name=${fontName}`.toLowerCase(),
      licenseHolder: (fontName) =>
        `/fonts/add/license-holder?name=${fontName}`.toLowerCase(),
      licenseTypes: (fontName) =>
        `/fonts/add/license-types?name=${fontName}`.toLowerCase(),
      styles: (fontName) => `/fonts/add/styles?name=${fontName}`.toLowerCase(),
    },
  },
  shop: {
    index: "/shop",
    product: (slug) => `/shop/${slug}`,
  },
  faq: "/faq",
};

export default Routes;
